<template>
  <CRow>
    <CCol col="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark">
        <template #header>
          <p class="mb-0" style="">
            <strong>{{ $store.state.table.announcement }}</strong>
          </p>
        </template>
        <CRow>
          <CCol cols="12" md="12" lg="12">
            <b-button variant="primary" class="mb-4" v-b-modal.modal-input>
              <CIcon name="cil-plus" />
              {{ $store.state.table.tambahModal }}
            </b-button>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
              <template #tipe-filter>
                <b-form-select v-model="filter.tipe" :options="tipeOptions"></b-form-select>
              </template>
              <template #file="{ item }">
                <td>
                  <b-button variant="info" class="mr-1" v-c-tooltip.hover.click="'Lihat File'" @click="openFile(item)"><CIcon name="cil-file" /> File</b-button>
                </td>
              </template>
              <template #createdAt="{ item }">
                {{ $moment(item.createdAt).format("YYYY-MM-DD") }}
              </template>
              <template #target="{ item }">
                <td>
                  <span v-if="item.all === true">All</span>
                  <span v-else-if="item.masterDivisiId">Divisi</span>
                  <span v-else-if="item.masterUserId">User</span>
                  <span v-else-if="item.masterPosisiId">Posisi</span>
                </td>
              </template>

              <!-- <template #Actions="{ item }">
                <td>
                  <b-button variant="info" class="mr-1" v-c-tooltip.hover.click="'Detail Data'" v-b-modal.modal-edit @click="data = item"><CIcon name="cil-file" /></b-button>
                </td>
              </template> -->
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </b-card>
    </CCol>
    <modal-edit :data="data" @alertFromChild="triggerAlert($event)" />
    <modal-input :userOptions="userOptions" :posisiOptions="posisiOptions" :divisiOptions="divisiOptions" @alertFromChild="triggerAlert($event)" />
  </CRow>
</template>

<script>
import modalInput from "./modalInput.vue";
import modalEdit from "./modalEdit.vue";

export default {
  components: {
    modalEdit,
    modalInput,
  },
  name: "Announcement",
  data() {
    return {
      data: {},
      items: [],
      filter: {
        tipe: null,
      },
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
      divisiOptions: [],
      posisiOptions: [],
      userOptions: [],
      tipeOptions: [
        { value: null, text: "All Type" },
        { value: "warning", text: "Warning" },
        { value: "birthday", text: "Birthday" },
        { value: "appreciation", text: "Appreciation" },
        { value: "announcement", text: "Announcement" },
      ],
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    fields() {
      return [
        {
          key: "no",
          label: this.$store.state.table.no,
          sortDirection: "desc",
          _classes: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "judul",
          label: this.$store.state.table.title,
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
          filter: false,
        },
        {
          key: "tipe",
          label: this.$store.state.table.tipe,
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
          filter: true,
        },
        {
          key: "target",
          label: this.$store.state.table.target,
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
          filter: false,
        },
        {
          key: "file",
          label: this.$store.state.table.file,
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
          filter: false,
        },
        {
          key: "createdAt",
          label: this.$store.state.table.tanggalDibuat,
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
          filter: false,
        },
        // {
        //   key: "tanggalBroadcast",
        //   label: this.$store.state.table.tanggalBroadcast,
        //   sortDirection: "desc",
        //   _classes: "text-left",
        //   sorter: false,
        //   filter: false,
        // },
        // {
        //   key: "Actions",
        //   label: this.$store.state.table.Actions,
        //   _classes: "table-option-2 text-center",
        //   filter: false,
        //   sorter: false,
        // },
      ];
    },
  },
  mounted() {
    this.getDatas();
    this.getDivisi();
    this.getPosisi();
    this.getUser();
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.tipe"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = { ...vm.filter, ...x };
      vm.currentPage = 1;
      vm.getDatas();
    },
    openFile(file) {
      if (!file) return;

      let kode = this.$store.state.kode_client ? this.$store.state.kode_client : null;
      let ip = `https://${kode}.storage.googleapis.com/`;
      let url = ip + file.file;
      const newTab = window.open(url, "_blank");
      if (!newTab || newTab.closed || typeof newTab.closed === "undefined") {
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", url.split("/").pop() || "file");
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let announ = await vm.$axios.post("announcement/list", {
        ...vm.filter,
        page: vm.currentPage,
        limit: vm.perPage,
        sortBy: "createdAt",
        sortType: "DESC",
      });
      // console.log("announ", announ);
      vm.items =
        announ.data.status == 200
          ? announ.data.data.map((x, idx) => {
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                // persetujuan: x.persetujuanPenandatanganan ? "Setuju" : "Tidak Setuju",
                // namaTanggalPenilaian: vm.$moment(x.tanggalPenilaian).format("LL"),
              };
            })
          : [];
      vm.totalRows = parseInt(announ.data.count);
      vm.loading = false;
    },
    async getDivisi() {
      const vm = this;
      vm.loading = true;
      let divisi = await vm.$axios.post("masterDivisi/list", {
        ...vm.filter,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      vm.divisiOptions =
        divisi.data.status == 200
          ? divisi.data.data.map((x) => {
              return {
                ...x,
                id: x.masterDivisiId,
                namaMitra: x.namaMitra || " - ",
              };
            })
          : [];
    },
    async getPosisi() {
      const vm = this;
      vm.loading = true;
      let posisi = await vm.$axios.post("masterPosisi/list", {
        ...vm.filter,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      vm.posisiOptions =
        posisi.data.status == 200
          ? posisi.data.data.map((x) => {
              return {
                ...x,
                id: x.masterposisiId,
                namaMitra: x.namaMitra || " - ",
              };
            })
          : [];
    },
    async getUser() {
      const vm = this;
      vm.loading = true;
      let user = await vm.$axios.post("user/ALL", {
        ...vm.filter,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      vm.userOptions =
        user.data.status == 200
          ? user.data.data.map((x) => {
              return {
                ...x,
                id: x.masteruserId,
                namaMitra: x.namaMitra || " - ",
              };
            })
          : [];
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
